import * as React from "react"
import { Box } from "@mui/material"
import {useAmazonReleaseDateReportForm} from "../../@hooks";
import { ActionButton } from "@components"


export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useAmazonReleaseDateReportForm()

    return <Box componet="span" data-tour="amazon-release-date-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}